import React from 'react';
import PropTypes from 'prop-types';

import {
  SearchInput,
  ClearButtonContainer,
  ClearButton,
  SearchInputContainer,
} from './styles';

const Search = (props) => {
  const {
    showClear,
    loading,
    onSearchChange,
    value,
    placeholder,
    onClear,
    width,
    showNoResults,
    onKeyDown,
    input,
    isWritten,
  } = props;

  return (
    <SearchInputContainer iswritten={+isWritten}>
      <SearchInput
        placeholder={placeholder}
        input={input}
        loading={loading}
        onSearchChange={onSearchChange}
        open={false}
        value={value}
        width={width}
        showNoResults={showNoResults}
        onKeyDown={onKeyDown}
        iswritten={+isWritten}
      />

      {showClear && onClear && (
        <ClearButtonContainer>
          <ClearButton onClick={onClear}>
            Clear
          </ClearButton>
        </ClearButtonContainer>
      )}

    </SearchInputContainer>
  );
};

Search.propTypes = {
  loading: PropTypes.bool,
  onSearchChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onClear: PropTypes.func,
  showClear: PropTypes.bool,
  width: PropTypes.string,
  showNoResults: PropTypes.bool,
  isWritten: PropTypes.bool,
  onKeyDown: PropTypes.func,
  input: PropTypes.shape({
    icon: PropTypes.string,
    iconPosition: PropTypes.string,
  }),
};

Search.defaultProps = {
  value: '',
  loading: false,
  placeholder: '',
  onClear: null,
  showClear: false,
  width: null,
  showNoResults: false,
  isWritten: false,
  onKeyDown: () => {},
  input: { icon: 'search', iconPosition: 'right' },
};

export default Search;
